
export const PRIVATE_KEY = `MIIJQgIBADANBgkqhkiG9w0BAQEFAASCCSwwggkoAgEAAoICAQCrVcgzFwx4OU9B
h4Et2BN89xzvXRCcg06X9KMNVOToFPoOiipVIzL0S2i17W9lTDtVFUzQq/i+agN+
BTyPc7zde3ioxteQK3eNIT032V5hMB4auVaPxDlT/ppTSIbHbI8OPWxKWyRonkPk
5+6m681ZVYb5XEaFZ1Mb5HToX3ECzt7Isv2j9SHZblWMC1z5aCUgdjYA+Xi4bwvi
Fw64c4M8PEftaFZjtvGDFWLu5ZHxK/HVmFJZAE8q6YuO8CKwFT9KbjbBKurfgAmB
FsKTGQIULafilZAPlBvExj9drSPb4hIuPx74PmD1lvCn7xdWv2ueIHHSropN7KFw
1RkibuUugUDAU2+mFRBlmIn/EAS3JHXjCnRO/wPmFrzoywzoHeGO3CP0ApZ+nxdM
VMLquEiZe+DnFndKSfINUh7xk41++6NdH8wYnG2m0qnJjN9TTgRSvZYyvqwjQIoI
KgREj4r+jFk8vP1hqxXtvyEQRS7m2+UThv3Llx8AdHDOoXxWikKM86OslxkWLE33
iChv/Ai60hFQz08Y9V/raRMGGxgwZ4Q88cmrnBL76TRGbIgKtcXvp/7woki/8aWi
NQL24qhwwq0uTZovBR+0pkpFtbi6pd/bGlUFvzmqWjimAKKy+NYptTuo4VtTLf3b
M+zQ7GiwKE0JNfsq3R8rjwm3IAm7IwIDAQABAoICAGxFtlEK5Ldox/wKLIkS/iW/
Z4qgDipKFDWUxCFdn5ZGA0uC5oOMzdtxeAdXt0iVZv06i6Nmubdi+Tf/CSlCI3z3
VOWbWofh4BfQhIYxmCHkrXGH4/rQLsY0o8OzlnCZ2sFN8Yv/kr+GHDOgmcDkTI2C
rdwRAwO0quF6eqKKBbmXj1PXQNAGzdBAmFD6sVNvC986tJ/jBvXOPv0uQwAvByTe
lzmg8M7swixrLGz5qEN22Ml5C7jwqBbfJXE7sUAC/U8E3RcvDuQUXm00O9uHNzgX
LfvTNgmSOAYendaN3pZKg+CzxNdtXAp2yzfksKQCLXjs2eEgqYfa3J6YG90VpT+3
sd+NYB6faOmxgZXJHZyBxrzifZ/Ec6Qr0exI10TwsFQzGdcoXXx6pbSXNmJMJvKs
MgGqPqIctsAJApchs5pSmMCCwlOUS/KpkaOELw7Z3dXw1THsuKawEVMKeFwtZruH
lpgGDAlpdzF9ncbSoU5idJ1g8ZitEcIUCCAlrTzgK8yB+BvYW8Y6oUeqOK1Owa5O
hnjqh8PIyyyC1W2JgHLKuYJLYQpyNJkXKX0DInTKg4X9COvPj7Nd/mpSP1B/UL+K
JTw05LX3mbgRJ5LNlMxjFZ/p83ZrgylNhKwePLiu8zknsFIMOWAkzl4NctXJsHhm
cCVRAMAy61TCqdnqTsuBAoIBAQDBzbpsE1HTCbiqgOXzLEl7v4b3HtcSeh2Qpi0Q
L160jjhXTcx9DOfhx9H4jsXxsFIIQqYlJeNDW8gMzrGyACisi/ojdGBAYmCcEGdZ
wAI+p/RgcNySdrgNIxAGO0UMNN5HDqBRqEksTuE6pfCtCTrgwJuxf+VW3ed+igh5
ZMaj8Xa0xuljEDUFKTH/ewfePb3/XY7Y7i5ZQRkOsdKrcyTk0BYYEWHqkrZWEt86
b3Z3L73R83LG1ORyIWp6w1tlTgNuqDZ4TMIL62VcHF74mY6Jj2W+3grrlDn0Itne
aBfsONp0zfzmWal7A+sdh8oZRcUA1Y7U2ZVDqu8mfFxa/qBBAoIBAQDiUhyy8FQv
yBnpDTm1beINGhXSv4UgeKUQllPqduQPm6RImvkBfN/xuIpoTPu44hRDWzY3ay0o
/Kp8RJJ2PuoVu/n2L+KypcCU/H0Isj8r85C06e3md5/fqeGvK/nPI4Htd13EeRr1
Xm+t/j7QUO9UAV2F0hqaUEvm+Ocd4MrEp7uPhM83hfexmKH7YEj8B9FWCdLnyufm
Is6IblcUABT0XtSm2gIUwSY0uCibFtrdzbfvzZYlm1zegaNb6UMLEKQwLnFTmZlg
1IabeOZUb+gsGfH7V7mD0R+qlKcrfVPWDWt4UsKIZuRwcYXYBPxc2Uk0KOiapFSq
ooesIQEqAUJjAoIBAQC114a3qVj5HwH6WX9pL4Czb/3/GRzL5XCgLIvTx96go2ER
6ZmZK+bW3lqRUcVBBSOzRHYIHQikRxXpjncEgUmovJ4zbhpxzty/ElUmzRZOG+Ec
LEmJ04LWMLP0ZOBgl6qIGZ0rgS9HN6v1D4ZHlYV9JLvxTAOwAf4XqQRSgtAvO30a
GhkaLjbRZNnY0WOMj3oahXpm6PTsIjyUoRz+aceQOf7BDm5FXutez85MUhFhu5Xr
zPVAwrimrdvu3CaBYzWtOoABWGQqMvCkAKrLr6kiQT5CXKz6ZdYK0DiEij8IEkBH
oI9Ow4pWNlMBHkvucpxqL/cYmB+JonVKMx2k840BAoIBABWTjnjgwKXthcraH+5U
E4D8Q6hb6e02k0YJjuaDfyqdxAPIAoVJym/ZEBjxfe4aX6QsRfbymNOXgwll4DC1
vstjqGj4F7zAYKPTjngNxkgCaIFW6/9U2EESiRmSL7a3w+NHxgC9KvzJjAwieQqT
LL3tg2UGqtKbZSEYCbCnha1J8G+2UasRcpPT4V19yHd+p050kU7X4VPnbZlEK7kU
aOsDP3LIxfoEkAfmprhibWtH+Yk7KF1denUcFt7kVifv5jdRtiwqMJ0ypcKcvBjA
snnB33f+3QjcHxC8K1PSFvQJQ32tJi6q4Ix3xjLaBtUzQe9fFw3nLMs3w4d9fgbr
J9ECggEAQOoLj9uc5mmE5bmbU4HItG/DpR2lmEkaZzSEa7tm0vTal3S0QYCx+0Ou
RvocBC4C1a3jcm+JbXYSr3V7WGQlz22TN8U/8adVvkPfCrEYizYnwZkigWr9a6eh
9lQJgs9XIdkUR5K/o9+Z8AZh7U6HriCs1UkvMrSAWajJQZaZUW70kgllDdvoOpwf
9p2wWz4VAbB8L4I1eWaLfLlNNdI3XMdkjR9tSAAwTftRbSejXXQEg9tIeRwvl85l
pqGhCthfbjn592mlB3yOfWhp/sQyBYst7hNEhx8DDpZzb94rFkHYcjLkLVHUP+6F
DjmZsuQKTCJ1dLjOaMEZEk08DKpiGg==`